/**
 * ActionPair — пара «Подтвердить / Отмена», единый стандарт (UNIBOOKING-DESIGN-CONTEXT
 * 28.07): обе кнопки одной геометрии 28px, «✓» 12px только на confirm, cancel — только
 * текст «Отмена». 03.10 (владелец: найм и увольнение в HR): переехала сюда из
 * screens/eo/QuestFormCells.tsx (там остался реэкспорт) — ею пользуются кадры и
 * ConfirmModal. Аддитивно: tone="danger" — красная левая кнопка без «✓» (единственное
 * исключение канона — удаление/увольнение), cancelDisabled — пока идёт запрос, okClassName.
 * Одиночная кнопка того же стандарта — классы css.abtn + css.solo (+ cf/dg).
 */
import css from "./ActionPair.module.css";

export { css as actionPairCss };

/** «✓» 12px — единственная иконка пары (эталон questIcons.CheckIco). */
export function CheckIco({ w = 12 }: { w?: number }) {
  return (
    <svg width={w} height={w} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.4} aria-hidden="true">
      <path d="M4 12l6 6L20 7" />
    </svg>
  );
}

export interface ActionPairProps {
  okLabel: string;
  onOk: () => void;
  onCancel: () => void;
  okDisabled?: boolean;
  cancelLabel?: string;
  cancelDisabled?: boolean;
  tone?: "confirm" | "danger";
  /** Доп. класс confirm-кнопки (screen-21 guard-модалка расширяет её). */
  okClassName?: string;
}

export function ActionPair(p: ActionPairProps) {
  const danger = p.tone === "danger";
  return (
    <div className={css.apair}>
      <button type="button" className={`${css.abtn} ${danger ? css.dg : css.cf}${p.okClassName ? ` ${p.okClassName}` : ""}`} disabled={p.okDisabled} onClick={p.onOk}>
        {danger ? null : <CheckIco />}
        {p.okLabel}
      </button>
      <button type="button" className={`${css.abtn} ${css.cl}`} disabled={p.cancelDisabled} onClick={p.onCancel}>
        {p.cancelLabel ?? "Отмена"}
      </button>
    </div>
  );
}
